import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import LeaguePlayerCreateEditForm from './Components/LeaguePlayerCreateEditForm';
import LeaguePlayerApi from './LeaguePlayerApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: LeaguePlayerCreateEditForm,
                getCreate: LeaguePlayerApi.create,
                getClone: LeaguePlayerApi.getOne,
                defaults: {},
                successMessage: "Player Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}